import React from 'react';
import { Users, UserPlus } from 'lucide-react';
import { useAuthContext } from '@/hooks/useAuthContext';

export const SettingsTeamCard: React.FC = () => {
  const { user, orgRole, orgName } = useAuthContext();

  const members = [
    {
      id: 'm1',
      name: user?.fullName || 'Current Partner',
      email: user?.primaryEmail || 'partner@conversora.io',
      role: orgRole || 'Owner',
      isYou: true,
      status: 'Active',
    },
  ];

  return (
    <div className="bg-[#0E1015] border border-zinc-800 rounded-2xl p-6 space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 pb-4 border-b border-zinc-800">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 rounded-lg bg-indigo-600/10 border border-indigo-500/20 flex items-center justify-center text-indigo-400">
            <Users className="w-4 h-4" />
          </div>
          <div>
            <h2 className="text-sm font-semibold text-white">Team Access & Workspace Roles</h2>
            <p className="text-xs text-zinc-400">
              Manage collaborators in <span className="text-zinc-200">{orgName || 'Primary Workspace'}</span>
            </p>
          </div>
        </div>

        <button
          type="button"
          className="flex items-center gap-2 px-3.5 py-2 bg-indigo-600 hover:bg-indigo-500 text-white rounded-xl text-xs font-semibold transition cursor-pointer shadow-xs self-start sm:self-auto"
        >
          <UserPlus className="w-3.5 h-3.5" />
          <span>Invite Member</span>
        </button>
      </div>

      <div className="border border-zinc-850 rounded-xl overflow-hidden">
        <table className="w-full text-left text-xs">
          <thead className="bg-zinc-900/60 border-b border-zinc-800 text-zinc-400 uppercase tracking-wider text-[10px]">
            <tr>
              <th className="py-3 px-4">Name</th>
              <th className="py-3 px-4">Email</th>
              <th className="py-3 px-4">Role</th>
              <th className="py-3 px-4 text-center">Status</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-zinc-850">
            {members.map((member) => (
              <tr key={member.id} className="hover:bg-zinc-900/40 transition">
                <td className="py-3.5 px-4 font-medium text-white flex items-center gap-2">
                  <span>{member.name}</span>
                  {member.isYou && (
                    <span className="text-[10px] px-1.5 py-0.5 rounded bg-indigo-500/15 text-indigo-400 border border-indigo-500/30">
                      You
                    </span>
                  )}
                </td>
                <td className="py-3.5 px-4 text-zinc-300 font-mono">{member.email}</td>
                <td className="py-3.5 px-4 text-zinc-300 capitalize">{member.role}</td>
                <td className="py-3.5 px-4 text-center">
                  <span className="inline-block px-2.5 py-0.5 rounded-full text-[10px] font-medium bg-emerald-500/10 text-emerald-400 border border-emerald-500/30">
                    {member.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="p-4 bg-zinc-900/40 border border-zinc-800 rounded-xl text-xs text-zinc-400">
        <p className="font-semibold text-zinc-300 mb-1">Role Permissions</p>
        <p>
          Owners have administrative and financial payout authority. Team members with Marketing access can view campaign attribution links and conversion metrics.
        </p>
      </div>
    </div>
  );
};
